'use no memo';
import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useIsDataClassificationEnabledForOrgQuery$data,
	useIsDataClassificationEnabledForOrgQuery$variables,
} from './__generated__/useIsDataClassificationEnabledForOrgQuery.graphql.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

const UseIsDataClassificationEnabledForOrgQuery = graphql`
	query useIsDataClassificationEnabledForOrgQuery {
		isDataClassificationEnabled
	}
`;

// hook to determine if data classification is enabled for org
export const useIsDataClassificationEnabledForOrg = ({ skip = false }: { skip?: boolean } = {}): {
	isEnabled: boolean;
	error: ApolloErrorInterop | undefined;
	loading: boolean;
} => {
	const { data, error, loading } = useQueryInterop<
		useIsDataClassificationEnabledForOrgQuery$data,
		useIsDataClassificationEnabledForOrgQuery$variables
	>(UseIsDataClassificationEnabledForOrgQuery, {
		context: { single: true },
		skip,
	});

	const isEnabled = Boolean(data?.isDataClassificationEnabled);

	return { isEnabled, error, loading };
};
